import React from 'react';

export const NoDataMessage: React.FC = () => {
  return (
    <div className="p-6 bg-yellow-50 dark:bg-yellow-900/20 rounded-lg border border-yellow-200 dark:border-yellow-800 text-center">
      <div className="flex flex-col items-center justify-center gap-3">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-yellow-500 dark:text-yellow-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
        <h3 className="text-lg font-medium text-yellow-800 dark:text-yellow-200">No articles found</h3>
        <p className="text-yellow-700 dark:text-yellow-300 max-w-md">
          No articles for the player could be found from sources available to the platform.
        </p>
      </div>
    </div>
  );
};